"use client";
'use strict';

var React = require('react');

const SiteSettingsContext = React.createContext(undefined);
const SiteSettingsProvider = SiteSettingsContext.Provider;

exports.SiteSettingsContext = SiteSettingsContext;
exports.SiteSettingsProvider = SiteSettingsProvider;
//# sourceMappingURL=SiteSettingsProvider.js.map
